import React from "react";
import styled from "styled-components";


export default styled.div`
    flex: 1 0 100%;
    padding: 0 0 0.5rem 0;
    color: rgb(78 153 214);
    font-weight: 700;
`;
